module.exports = __webpack_public_path__ + "29c948fac7a4832c3333d9288879c936.png";